import AuthModal from './auth/authModalComponent';
import FiltersModal from './filters';
import ChangeLogoModal from './changeLogo';
import ChangePassModal from './changePass';

export { AuthModal, FiltersModal, ChangeLogoModal, ChangePassModal }
